module.exports = __webpack_public_path__ + "img/bank-left-type2.afe0f4c0.png";